export default [
  {
    path: '/applications/material',
    name: 'applications-material',
    component: () => import('@/views/modules/Applications/material/material.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'reference.material',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/material/',
    name: 'add-material',
    component: () => import('@/views/modules/Applications/material/addMaterial.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'reference.material',
          to: '/applications/material',
          active: false,
        },
        {
          text: 'adding',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/material/:id',
    name: 'add-material-id',
    component: () => import('@/views/modules/Applications/material/addMaterial.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'reference.material',
          to: '/applications/material',
          active: false,
        },
        {
          text: 'editing',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/material/view/:id',
    name: 'add-material-view-id',
    component: () => import('@/views/modules/Applications/material/viewMaterial.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'reference.material',
          to: '/applications/material',
          active: false,
        },
        {
          text: 'watch',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/instrument',
    name: 'applications-instrument',
    component: () => import('@/views/modules/Applications/instrument/instrument.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'reference.instrument',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/instrument/',
    name: 'add-instrument',
    component: () => import('@/views/modules/Applications/instrument/addInstrument.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'reference.instrument',
          to: '/applications/instrument',
          active: false,
        },
        {
          text: 'adding',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/instrument/:id',
    name: 'add-instrument-id',
    component: () => import('@/views/modules/Applications/instrument/addInstrument.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'reference.instrument',
          to: '/applications/instrument',
          active: false,
        },
        {
          text: 'editing',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/instrument/view/:id',
    name: 'add-instrument-view-id',
    component: () => import('@/views/modules/Applications/instrument/viewInstrument.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'reference.instrument',
          to: '/applications/instrument',
          active: false,
        },
        {
          text: 'watch',
          active: true,
        },
      ],
    },
  },
  {
    path: '/forpurchase',
    name: 'for-sale',
    component: () => import('@/views/modules/Applications/ForSale/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'sidebar.for_purchase',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/transport/',
    name: 'applications-transport',
    component: () => import('@/views/modules/Applications/transport/transport.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'transport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/transport/',
    name: 'add-transport',
    component: () => import('@/views/modules/Applications/transport/addTransport.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'transport',
          to: '/applications/transport',
          active: false,
        },
        {
          text: 'adding',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/transport/:id',
    name: 'add-transport-id',
    component: () => import('@/views/modules/Applications/transport/addTransport.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'transport',
          to: '/applications/transport',
          active: false,
        },
        {
          text: 'editing',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/transport/view/:id',
    name: 'add-transport-view-id',
    component: () => import('@/views/modules/Applications/transport/viewTransport.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'transport',
          to: '/applications/transport',
          active: false,
        },
        {
          text: 'watch',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/works/',
    name: 'applications-works',
    component: () => import('@/views/modules/Applications/works/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'application_for_works',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/works/',
    name: 'add-works',
    component: () => import('@/views/modules/Applications/works/addWorks.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'application_for_works',
          to: '/applications/works',
          active: false,
        },
        {
          text: 'adding',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/works/:id',
    name: 'add-works-id',
    component: () => import('@/views/modules/Applications/works/addWorks.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'application_for_works',
          to: '/applications/works',
          active: false,
        },
        {
          text: 'editing',
          active: true,
        },
      ],
    },
  },
  {
    path: '/applications/works/view/:id',
    name: 'add-works-view-id',
    component: () => import('@/views/modules/Applications/works/viewWorks.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'application_for_works',
          to: '/applications/works',
          active: false,
        },
        {
          text: 'watch',
          active: true,
        },
      ],
    },
  },
  {
    path: '/write-offs',
    name: 'write-offs',
    component: () => import('@/views/modules/Applications/writeOffs/index.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'sidebar.list_of_applications',
          active: true,
        },
        {
          text: 'write-offs',
          active: true,
        },
      ],
    },
  },





]
